<template>
  <div v-if="maintenanceMessage && !isDismissed" class="maintenance-note marquee">
    <button class="close-btn" type="button" aria-label="Close maintenance notification" @click="closeBanner">❌</button>
    <div class="marquee-track">
      <span v-for="i in 2" :key="i">
        <strong>{{ maintenanceMessage.strong }}</strong> {{ maintenanceMessage.weak }}
        <a class="email-link" :href="`mailto:${maintenanceMessage.email}`">{{ maintenanceMessage.email }}</a>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import * as env from '@/common/environment';
import { useMaintenanceStatus } from '@/common/MaintenanceLib';
import { i18n } from '@/plugins/i18n';

const isMaintenanceEnabled = Boolean(env.get('maintenanceMode')?.enabled);
const isDismissed = ref(false);

const closeBanner = () => {
  isDismissed.value = true;
};

const maintenanceStatus = useMaintenanceStatus(isMaintenanceEnabled);

const maintenanceMessage = computed(() => {
  if (!isMaintenanceEnabled) return null;
  if (maintenanceStatus.value !== 'ongoing') return null;
  // Ongoing maintenance - fetch message from environment
  const locale = i18n.locale;
  const message = env.getMaintenanceMessage(locale);
  return message;
});
</script>

<style lang="scss" scoped>
@import '@/assets/scss/base.scss';

.maintenance-note {
  position: relative;
  background-color: $maintenance-banner-bg;
  color: $maintenance-banner-text-color;
  text-align: center;
  padding: 0.8rem 2.8rem 0.8rem 0.8rem;
  font-size: $size-m;
}

.email-link {
  color: $maintenance-banner-link-text-color;
  text-decoration: underline;
}

.close-btn {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  border: 0;
  background: $maintenance-banner-bg;
  padding: 10px;
  cursor: pointer;
  line-height: 1;
  font-size: 1rem;
  z-index: 2;
}

.marquee {
  overflow: hidden;
  white-space: nowrap;
}

.marquee-track {
  display: flex;
  width: max-content;
  animation: scroll-marquee 30s linear infinite;
}

.marquee-track span {
  padding-right: 50px; /* spacing between repeats */
}

@keyframes scroll-marquee {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
</style>
